<template>
  <video-player
      v-if="image.subFileResourceUri"
      ref="videoPlayer"
      :options="getPlayerOption(image)"
      :playsinline="true"
      class="video-player-box answer-video"
  />
  <div v-else class="back-image-data t-center">
    <img :src="thumbnailUrl" alt="" class="mgx-auto">
    <div class="font-size-adjust t-subtitle3 font-m centered t-color-gray3"> 동영상이 처리 중입니다. 나중에
      다시 확인하세요.
    </div>
  </div>
</template>
</template>

<script>

import 'video.js/dist/video-js.css'

export default {
  name: "VideoPlayer",

  props: ['image', 'imgHeight', 'imgWidth'],

  components: {
    videoPlayer,
  },

  data() {
    return {
      thumbnailUrl: require("@/images/blackBackground.jpg")
    }
  },

  methods: {
    getPlayerOption(img) {
      return {
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: img.contentType,
            src: img.resourceUri
          }
        ],
        height: this.imgHeight,
        width: this.imgWidth,
        poster: img.subFileResourceUri ? img.subFileResourceUri[0] : this.thumbnailUrl
      };
    }
  }
}
</script>

<style scoped>
.back-image-data img {
  height: 104px;
  width: 104px;
  border-radius: 4px;
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 3px;
}

.font-size-adjust {
  font-size: 7px !important;
}

</style>